import ListSampleReceiptsPage from './ListSampleReceiptsPage';
import LoadingSpinner from '../../../components/LoadingSpinner';
import { OwnerType } from '../../../common/constants';
import { skipToken } from '@reduxjs/toolkit/dist/query';
import { useGetStoreByIdQuery } from '../../stores/store.api-slice';
import { useParams } from 'react-router-dom';

const ListStoreSampleReceiptsPage: React.FC = () => {
  const { id } = useParams();
  const { data, isLoading } = useGetStoreByIdQuery(id != null ? id : skipToken);

  if (isLoading || id == null) {
    return <LoadingSpinner />;
  }

  return (
    <ListSampleReceiptsPage filter="store" merchantStore={data} ownerEntityType={OwnerType.STORE} ownerEntity={data} />
  );
};

export default ListStoreSampleReceiptsPage;
